import { useState } from 'react'

import PageTitle from '@components/PageTitle/PageTitle'
import { faChevronLeft } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import usePageHeight from '@hooks/usePageHeight'
import { Box, Breadcrumbs, IconButton, Stack, Typography } from '@mui/material'
import { DirectDealBasket } from '@services/marketBasketReports.types'
import BasketList from '@views/Analytics/ActionCenter/DirectDeals/BasketList/BasketList'
import DirectDealDetail from '@views/Analytics/ActionCenter/DirectDeals/DirectDealDetail/DirectDealDetail'
import { useNavigate } from 'react-router-dom'

export default function DirectDealsReport() {
	const [selectedBasket, setSelectedBasket] = useState<DirectDealBasket | null>(null)
	const contentHeight = usePageHeight({ pageTitle: true })

	return (
		<Box width="100%">
			<PageTitle documentTitle="Direct Deals" title={<Title />} />
			<Stack
				direction="row"
				spacing={1}
				sx={{ height: contentHeight, overflow: 'hidden', px: '2rem', pb: '1rem' }}
			>
				<BasketList onSelectBasket={setSelectedBasket} />
				<DirectDealDetail selectedBasket={selectedBasket} />
			</Stack>
		</Box>
	)
}

function Title() {
	const navigate = useNavigate()

	return (
		<Breadcrumbs>
			<IconButton
				aria-label="Back to Analytics"
				onClick={() => navigate('/app/market-baskets/analytics/action-center')}
				color="info"
			>
				<FontAwesomeIcon icon={faChevronLeft} size="sm" />
			</IconButton>
			<Typography color="text.primary" variant="body1">
				Direct Deals
			</Typography>
		</Breadcrumbs>
	)
}
